import { useState } from "react";
import { CalendarDays, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, can } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";
import { DayInput } from "@/components/DayInput";
import { Button } from "@/components/ui/button";

const PERM = { sales: ["caisse", "modifier"], transfers: ["transferts", "modifier"], stock_docs: ["stock", "modifier"], purchases: ["fournisseurs", "modifier"] };

// kind: sales | transfers | stock_docs | purchases
export const DocDateEditor = ({ kind, doc, onChanged }) => {
  const { user } = useAuth();
  const [date, setDate] = useState((doc?.created_at || "").slice(0, 10));
  const [open, setOpen] = useState(false);
  if (!doc || !can(user, ...PERM[kind])) return null;
  const save = async () => {
    try { const { data } = await api.patch(`/documents/${kind}/${doc.id}/date`, { date }); toast.success("Date du document modifiée"); setOpen(false); onChanged?.(data.created_at); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <span className="inline-flex items-center gap-1 print:hidden" data-testid="doc-date-editor">
      {!open ? <button type="button" className="inline-flex items-center gap-1 text-xs text-[#059669] hover:underline" onClick={() => setOpen(true)} data-testid="doc-date-edit-btn"><CalendarDays size={12} /> Modifier la date</button>
        : <><DayInput value={date} maxToday={false} onChange={setDate} className="h-7 w-36 text-xs" data-testid="doc-date-input" /><Button size="sm" className="h-7 bg-emerald-600 hover:bg-emerald-700" onClick={save} data-testid="doc-date-save"><Check size={12} /></Button><Button size="sm" variant="ghost" className="h-7" onClick={() => setOpen(false)}>Annuler</Button></>}
    </span>
  );
};
